import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'faSvg'
  },
  theme: {
    themes: {
      light: {
        primary: colors.teal.base
      //       secondary: colors.teal.lighten4,
      //       accent: colors.shades.black,
      //       error: colors.red.accent3,
      //       info: colors.green.lighten2
      }
    }
  }
})
